import { render, staticRenderFns } from "./studioDashboardEmployee.vue?vue&type=template&id=5474322d&scoped=true"
import script from "./studioDashboardEmployee.vue?vue&type=script&lang=js"
export * from "./studioDashboardEmployee.vue?vue&type=script&lang=js"
import style0 from "./studioDashboardEmployee.vue?vue&type=style&index=0&id=5474322d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5474322d",
  null
  
)

export default component.exports